// Engagement analytics: which layer a displayed artifact belongs to, and
// whether this page session has already reported that layer
// (RecordLayerOpened).
//
// The server tags each artifact's metadata JSON with its `object_key` and its
// `output_layer`, derived by the one parser (web-server/domain/project_object_key.go).
// The client dedupes on the layer, so a layer holding several artifacts counts
// once, and sends the object key, from which the server derives the layer it
// records.
//
// Pure and import-free so the node test runner can load it directly.
/** The object_key and output_layer in an artifact's metadata JSON; "" for each when absent or unreadable. */
export function artifactLayerFromMetadataJson(metadataJson) {
    const none = { objectKey: '', layer: '' };
    if (!metadataJson)
        return none;
    let parsed;
    try {
        parsed = JSON.parse(metadataJson);
    }
    catch (_a) {
        return none;
    }
    if (!parsed || typeof parsed !== 'object')
        return none;
    const { object_key: objectKey, output_layer: layer } = parsed;
    return {
        objectKey: typeof objectKey === 'string' ? objectKey : '',
        layer: typeof layer === 'string' ? layer : '',
    };
}
/**
 * Returns a function that answers true the first time it sees a
 * (project, layer) pair and false after, so switching on a layer's artifacts
 * in one page session reports the layer once. Page memory only: a reload
 * starts fresh.
 */
export function createLayerOpenDeduper() {
    const seen = new Set();
    return (projectId, layer) => {
        const key = JSON.stringify([projectId, layer]);
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    };
}
